
function SdOrderFilesCtrl(TranslationService, MaterialService, StoreService, ToastService, DocService, $uibModal, $window) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.$onInit = function () {
        console.log('$onInit sd-order-files');
        
    };

    ctrl.$onChanges = function (newValues, oldValues) {
        //console.log('SD-ORDER-ITEMS.ONCHANGES');
        if (newValues.order) {
            if (newValues.order.currentValue && newValues.order.currentValue.Details) {
                //ctrl.prepareForEdit(newValues.order.currentValue);
            }
        }
    };

    //JRM: PEGAR DO CADASTRO DE DOCUMENTOS
    ctrl.getFileType = function (file) {
        var name = file.Name;
        //console.log('getFileType ' + name);
        if (name) {
            switch (name.substr(0, 2)) {
                case '01':
                    return 'Order Confirmation';
                case '02':
                    return 'Invoice';
                case '03':
                    return 'Packing List';
                case '04':
                    return 'ISF';
                case '05':
                    return 'Lacey Act';
                case '06':
                    return 'Shipment Advice';
                case '07':
                    return 'Certificado HT';
                case '17':
                    return 'Softwood Lumber Declaration';
                case '50':
                    return 'Bill of Lading';
                default:
                    return '_';
            }
        }
    };
    

    ctrl.showPdf = function (order, doc) {
        var modalInstance = $uibModal.open({
            templateUrl: 'SPA/orders/showPdfModal.html',
            controller: 'ShowPdfCtrl',
            size: 'xl',
            resolve: {
                order: function () {
                    return order;
                },
                doc: function () {
                    return doc;
                }
            }
        });
        modalInstance.result.then(function (selectedItem) { });
    };



    ctrl.getFile = function (file) {
        return DocService.showFile(ctrl, file.Name, file.AbsolutePath);
    };

    ctrl.getFileExtension = function (fileName) {
        return DocService.getFileExtension(fileName);      
    };
}

SdOrderFilesCtrl.$inject = ['TranslationService', 'MaterialService', 'StoreService', 'ToastService', 'DocService', '$uibModal', '$window'];

seedWebApp.component('sdOrderFiles', {
    controller: SdOrderFilesCtrl,
    bindings: {
        loading: '<',
        order: '<',
        files: '<',
        disabled: '<',
        loadingError: '<'
    },
    templateUrl: '/SPA/Orders/sd-order-files.html' + seedWebApp.buildVersion
});
